import { array, boolean, object } from 'yup';

import { validationErrMessages } from '@constants/validationConstants';

export const schema = object({
	importType: object()
		.nullable()
		.required(validationErrMessages.importType),
	skipEmptyFields: boolean(),
	skipFields: array()
		.nullable()
		.default(null),
});
